// optimus.agGridTables.alias
export enum AgGridTableAlias {
  Funnel = 'funnel',
  LegacyFunnel = 'legacy-funnel',
  SbaFunnel = 'sba-funnel',
}